import { render, staticRenderFns } from "./PlatDynamic.vue?vue&type=template&id=6f410d87"
import script from "./PlatDynamic.vue?vue&type=script&lang=js"
export * from "./PlatDynamic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports